export default __webpack_public_path__ + "static/freadomLogo-d41d0154286ef3235a4e294aa4fe99d7.png";